import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import { DateUtils } from '@/utils/DateUtils';
import { MoneyUtils } from '@/utils/MoneyUtils';
import { PayoutSummary } from '@/interfaces/PayoutSummary';


export default /*#__PURE__*/_defineComponent({
  __name: 'PayoutSummary',
  props: {
  consultations: {
    type: Array as () => PayoutSummary[],
    required: true
  }
},
  setup(__props) {

const props = __props;

const loading = ref(false);

const safeDisplay = (value: string): string => value || '';

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(DataTable), {
      value: props.consultations,
      loading: loading.value,
      size: "small",
      dataKey: "consultationId",
      class: "p-datatable-sm"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Column), { header: "Pacient" }, {
          body: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(safeDisplay(data.patientFirstName) + ' ' + safeDisplay(data.patientLastName)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), { header: "Data" }, {
          body: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(_unref(DateUtils).format(data.consultationDate)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), { header: "Valoare" }, {
          body: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(_unref(MoneyUtils).format(data.consultationAmount, data.currency || 'RON')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "loading"])
  ]))
}
}

})